import React, { useEffect, useState } from 'react';
import Icon from '../../../../../../common/client/components/Icon/Icon';
import { BrowseInfo } from '../../../../../common/client/models/Browse';
import '../../../../../../common/client/styles/base.css';
import styles from './BrowsePage.module.css';
import axios from 'axios';
import { FacetOption } from '../../../../../common/entities/Facet';
import DynascoreRow from '../../../components/public/DynascoreRow/DynascoreRow';
import Nav from '../../../components/public/Nav/Nav';
import OldNav from '../../../components/public/OldNav/OldNav';

const wonderLogo = require('../../../../static/Wonder_Logo_White.svg').default;
const dynascoreLogo =
  require('../../../../static/Dynascore_Logo_White_Wordmark.svg').default;

interface IProps {}

export const BrowsePage: React.FC<IProps> = () => {
  const [info, setInfo] = useState<BrowseInfo>();
  const [search, setSearch] = useState<string>('');
  const [showSearchResults, setShowSearchResults] = useState<boolean>();
  const [searchResults, setSearchResults] = useState<any[]>();

  useEffect(() => {
    axios
      .get<BrowseInfo>('/dynascore/browse/info')
      .then((response) => setInfo(response.data));
  }, []);

  const onSearchSubmit = (event) => {
    event.preventDefault();
    setShowSearchResults(true);
    axios
      .get<any[]>('/dynascore/browse/search?q=' + encodeURIComponent(search))
      .then((response) => setSearchResults(response.data));
  };

  return (
    <div>
      <OldNav />

      <div className={styles.content}>
        <img
          className={styles.dynascoreLogo}
          src={dynascoreLogo}
          title="Dynascore"
          onClick={() => {
            window.location.href = '/dynascore/browse';
          }}
        />

        {!showSearchResults && (
          <>
            <div className={styles.title}>Browse Dynascore</div>
            <div className={styles.subtitle}>
              Find royalty-free background music that perfectly fits your video
            </div>
          </>
        )}
        {showSearchResults && (
          <button
            className={styles.back}
            onClick={() => setShowSearchResults(false)}
          >
            &lt; back
          </button>
        )}
        <div className={styles.searchContainer}>
          <div className={styles.searchIcon}>
            <Icon name="search" />
          </div>

          <form onSubmit={onSearchSubmit}>
            <input
              placeholder="mood, genre, and more"
              className={styles.searchInput}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </form>
        </div>
        {!showSearchResults && (
          <>
            <div className={styles.sectionTitle}>Genres</div>
            <div className={styles.genreContainer}>
              {info?.genres.map((genre) => (
                <a
                  className={styles.genre}
                  key={genre.name.toLowerCase().replace(' ', '_')}
                  href={
                    '/dynascore/browse/genre/' +
                    genre.name.toLowerCase().replace(' ', '_').replace('&', '_')
                  }
                >
                  {genre.name}
                </a>
              ))}
            </div>
            {info?.sections.map((section) => (
              <div key={section.title}>
                <div
                  className={styles.sectionTitle + ' ' + styles.playlistTitle}
                >
                  {section.title}
                </div>
                {section.compositions.map((comp) => (
                  <DynascoreRow
                    key={comp.prefixKey}
                    genre={getGenre(info.genres, comp.facetOptionIds)}
                    comp={...comp}
                  />
                ))}
              </div>
            ))}
          </>
        )}
        {showSearchResults && (
          <>
            {searchResults?.map((comp) => (
              <DynascoreRow
                key={comp.prefixKey}
                genre={getGenre(info.genres, comp.facetOptionIds)}
                comp={...comp}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

let getGenre = (genres: FacetOption[], ids: string[]) => {
  if (!ids) {
    return undefined;
  }
  for (const id of ids) {
    const genre = genres.find((o) => o.id === id);
    if (genre) {
      return genre.name;
    }
  }
};
